export default __webpack_public_path__ + "static/media/BMW-after.77ef2b5e.jpg";